module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "site-nav"
  }, [_c('transition-group', {
    staticClass: "d-flex",
    attrs: {
      "tag": "div",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeLinkEnter,
      "enter": _vm.linkEnter,
      "leave": _vm.linkLeave
    }
  }, [(!_vm.isHome) ? _c('router-link', {
    key: "ruyi",
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".ruyi")
      },
      "data-enter": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.title')))]) : _vm._e(), _vm._v(" "), (!_vm.isHome) ? _c('router-link', {
    key: "technology",
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".technology")
      },
      "data-enter": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.title')))]) : _vm._e(), _vm._v(" "), (!_vm.isHome) ? _c('router-link', {
    key: "fashion",
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion")
      },
      "data-enter": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.title')))]) : _vm._e(), _vm._v(" "), (!_vm.isHome) ? _c('router-link', {
    key: "sustainability",
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability")
      },
      "data-enter": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.title')))]) : _vm._e()], 1), _vm._v(" "), _c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.ruyi-news.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.ruyi-news.title')))]), _vm._v(" "), _c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.contact.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.contact.title')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-836daebe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/LandingHeader/SiteNav.vue
// module id = 634
// module chunks = 1